// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".C20Tub7ZFrsCa- {\n  padding-left: 5px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"learnMoreLink": "C20Tub7ZFrsCa-"
};
export default ___CSS_LOADER_EXPORT___;
